'use es6';

import PropTypes from 'prop-types';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.video.lite.${suffix}`;
const propTypes = {
  onEdit: PropTypes.func.isRequired,
  onReplace: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
function VideoPopoverBodyLite(props) {
  const {
    onEdit,
    onReplace,
    onRemove
  } = props;
  const iconButtons = [{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REPLACE,
    onClick: onReplace
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onRemove
  }];
  return /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
    "data-test-id": "video-popover-body-lite",
    iconButtons: iconButtons,
    i18nKey: i18nKey
  });
}
VideoPopoverBodyLite.propTypes = propTypes;
VideoPopoverBodyLite.displayName = 'VideoPopoverBodyLite';
export default VideoPopoverBodyLite;